import { AppShell } from "../../src/components/layout/AppShell";
import { Feed } from "../../src/components/feed/Feed";

export default function Page() {
  return (
    <AppShell currentNavId="home" loggedIn={false}>
      <Feed />
    </AppShell>
  );
}
